export default __webpack_public_path__ + "static/media/grupo-rojemac.82cad1b6.webp";